module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURdHj/9Dk/0dwTNHk/9Dj/0OO9oS1+merbnIAAAAFdFJOU6nrABwb0jCp3gAAACRJREFUCNdjUGYUcGIwTA0TZmALDU1gEA0NDYQQYC5YAqjECACNmwcbPsOeZAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontierPage/article-title-ellipse.png
// module id = FFA2
// module chunks = 0